'use strict'

import Helper from '@/utils/helper'

class StatusRequest {
  constructor({pointId, saleId, saleCode}) {
    Helper.checkString('StatusRequest.pointId', pointId)
    Helper.checkString('StatusRequest.saleId', saleId)
    Helper.checkString('StatusRequest.saleCode', saleCode)

    this.pointId = pointId
    this.saleId = saleId
    this.saleCode = saleCode
  }

  getPointId() {
    return this.pointId
  }

  getSaleId() {
    return this.saleId
  }

  getSaleCode() {
    return this.saleCode
  }

  toString() {
    return 'StatusRequest{' +
      'pointId=' + '\'' + this.pointId + '\'' +
      ', saleId=' + '\'' + this.saleId + '\'' +
      ', saleCode=' + '\'' + this.saleCode + '\'' +
      '}'
  }
}

export default StatusRequest
